import SimpleCrypto from 'simple-crypto-js'
// eslint-disable-next-line import/no-cycle
import { getSecretUserKey } from './vk-utils'

export async function decrypt(encryptedToken) {
  const secretKey = await getSecretUserKey()
  const simpleCrypto = new SimpleCrypto(secretKey)
  return simpleCrypto.decrypt(encryptedToken)
}
